// extracted by mini-css-extract-plugin
export default {"box":"gfLYph6XfUW1Q6i_6KMR","text":"VvqnYIW_GZN2S9r7vOJ6"};